import { createStore } from "vuex";

const store = createStore({
    state: {
        drawingEnabled: false
    }
})

export default store;